import PropTypes from 'prop-types';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Button } from 'components/Button';

const SubmitButton = ({
	name = 'submit', children, buttonStyleVariant, size, ariaDisabled = () => {}
}) => {

	const { register, formState } = useFormContext();

	return (
		<Button
			name={name}
			type="submit"
			ref={register}
			loading={formState.isSubmitting}
			aria-disabled={formState.isSubmitting || ariaDisabled()}
			buttonStyleVariant={buttonStyleVariant}
			size={size}
		>
			{children || name}
		</Button>
	);

};

SubmitButton.propTypes = {
	name: PropTypes.string,
	children: PropTypes.node,
	buttonStyleVariant: PropTypes.string,
	size: PropTypes.string,
	ariaDisabled: PropTypes.func
};

export default SubmitButton;
